"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CabucStatusCode = exports.StaticUpdateType = void 0;
var StaticUpdateType;

(function (StaticUpdateType) {
  StaticUpdateType["Expiring"] = "Expiring";
  StaticUpdateType["OldGost2001"] = "OldGost2001";
})(StaticUpdateType = exports.StaticUpdateType || (exports.StaticUpdateType = {}));

var CabucStatusCode;

(function (CabucStatusCode) {
  CabucStatusCode[CabucStatusCode["DoNotNeedUpdate"] = 0] = "DoNotNeedUpdate";
  CabucStatusCode[CabucStatusCode["NeedNewCertificate"] = 1] = "NeedNewCertificate";
  CabucStatusCode[CabucStatusCode["VisitRCIsNeccessary"] = 2] = "VisitRCIsNeccessary";
  CabucStatusCode[CabucStatusCode["Validating"] = 3] = "Validating";
  CabucStatusCode[CabucStatusCode["ReadyForRequestGeneration"] = 4] = "ReadyForRequestGeneration";
  CabucStatusCode[CabucStatusCode["Releasing"] = 5] = "Releasing";
  CabucStatusCode[CabucStatusCode["Released"] = 6] = "Released";
  CabucStatusCode[CabucStatusCode["Rejected"] = 7] = "Rejected";
  CabucStatusCode[CabucStatusCode["Installed"] = 8] = "Installed";
  CabucStatusCode[CabucStatusCode["EditingInRC"] = 9] = "EditingInRC";
  CabucStatusCode[CabucStatusCode["ErrorInVCR"] = 11] = "ErrorInVCR";
  CabucStatusCode[CabucStatusCode["StrangeForms"] = 96] = "StrangeForms"; // Статусы геракла

  CabucStatusCode[CabucStatusCode["HeraclesDoNotNeedUpdate"] = 100] = "HeraclesDoNotNeedUpdate";
  CabucStatusCode[CabucStatusCode["HeraclesNeedNewCertificate"] = 101] = "HeraclesNeedNewCertificate";
  CabucStatusCode[CabucStatusCode["HeraclesVisitRCIsNeccessary"] = 102] = "HeraclesVisitRCIsNeccessary";
  CabucStatusCode[CabucStatusCode["HeraclesValidating"] = 103] = "HeraclesValidating";
  CabucStatusCode[CabucStatusCode["HeraclesReadyForRequestGeneration"] = 104] = "HeraclesReadyForRequestGeneration";
  CabucStatusCode[CabucStatusCode["HeraclesReleasing"] = 105] = "HeraclesReleasing";
  CabucStatusCode[CabucStatusCode["HeraclesReleased"] = 106] = "HeraclesReleased";
  CabucStatusCode[CabucStatusCode["HeraclesRejected"] = 107] = "HeraclesRejected";
  CabucStatusCode[CabucStatusCode["HeraclesInstalled"] = 108] = "HeraclesInstalled";
  CabucStatusCode[CabucStatusCode["HeraclesEditingInRC"] = 109] = "HeraclesEditingInRC";
  CabucStatusCode[CabucStatusCode["HeraclesErrorInVCR"] = 111] = "HeraclesErrorInVCR";
  CabucStatusCode[CabucStatusCode["HeraclesStrangeForms"] = 196] = "HeraclesStrangeForms";
  CabucStatusCode[CabucStatusCode["HeraclesContinueUpdate"] = 130] = "HeraclesContinueUpdate";
  CabucStatusCode[CabucStatusCode["HeraclesFinishUpdate"] = 131] = "HeraclesFinishUpdate";
  CabucStatusCode[CabucStatusCode["HeraclesReissueCertWithServiceCenter"] = 140] = "HeraclesReissueCertWithServiceCenter";
  CabucStatusCode[CabucStatusCode["HeraclesReissueCertWithCS"] = 141] = "HeraclesReissueCertWithCS";
  CabucStatusCode[CabucStatusCode["HeraclesReissueCertWithHeracles"] = 151] = "HeraclesReissueCertWithHeracles";
  CabucStatusCode[CabucStatusCode["HeraclesTrialCertificate"] = 160] = "HeraclesTrialCertificate";
  CabucStatusCode[CabucStatusCode["HeraclesFreeProlongation"] = 161] = "HeraclesFreeProlongation";
  CabucStatusCode[CabucStatusCode["HeraclesReissueActiveCert"] = 171] = "HeraclesReissueActiveCert";
  CabucStatusCode[CabucStatusCode["HeraclesReissueExternalCACert"] = 181] = "HeraclesReissueExternalCACert";
  CabucStatusCode[CabucStatusCode["HeraclesKStoreProlongation"] = 201] = "HeraclesKStoreProlongation"; // Выпуск сертификата через KStore
})(CabucStatusCode = exports.CabucStatusCode || (exports.CabucStatusCode = {}));